"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MonthlySavingsState_1 = require("./MonthlySavingsState");
var msstyles = require("./MonthlySavings.scss");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var styles = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../../api/ReportingService");
var Utils = require("../../../../utils/UtilityFunctions");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var MonthlySavings_cms_1 = require("./MonthlySavings.cms");
var MonthlySavingsPanel_1 = require("../../../panels/MonthlySavingsPanel/MonthlySavingsPanel");
var components_1 = require("@idp/duc/components");
var MonthlySavings = /** @class */ (function (_super) {
    __extends(MonthlySavings, _super);
    function MonthlySavings(props) {
        var _this = _super.call(this, props) || this;
        _this.totalSaving = 0;
        _this.state = new MonthlySavingsState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.seeYourSaving = _this.seeYourSaving.bind(_this);
        _this.checkMonthlySavings = _this.checkMonthlySavings.bind(_this);
        _this.isExistingPriceChanged = _this.isExistingPriceChanged.bind(_this);
        return _this;
    }
    MonthlySavings.prototype.render = function () {
        var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
        if (cmsData && cmsData.common && cmsData.common.monthlySavingsPanel) {
            this.cmsContent = cmsData.common.monthlySavingsPanel;
        }
        else {
            this.cmsContent = new MonthlySavings_cms_1.MonthlySavingsCms();
        }
        if (this.props && this.props.data && this.props.data.showMonthlySaving) {
            return (React.createElement(React.Fragment, null, this.checkMonthlySavings()));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    MonthlySavings.prototype.seeYourSaving = function (show) {
        if (show) {
            this.reportingService.fireLinkClickWithOutPageLoad(this.cmsContent.seeYourSavingLinkLabel, ReportingService_1.PageUrls.CART_PAGE);
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.MONTHLY_SAVINGS_MODAL);
            this.setState({ showMonthlySavingsModal: true });
        }
        else {
            this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            this.setState({ showMonthlySavingsModal: false });
        }
    };
    MonthlySavings.prototype.checkMonthlySavings = function () {
        var _this = this;
        var showOnlyLink = this.props.data && this.props.data.showOnlyLink || false;
        this.monthlySavings = this.props.data && this.props.data.monthlySavings;
        var showMonthlySavingsMessage = false;
        if (this.monthlySavings && this.monthlySavings.content && this.monthlySavings.content.payload &&
            this.monthlySavings.content.payload.planPrice) {
            var isCommonCart = Utils.isCommonCartPresent();
            var currentPrice_1 = 0;
            var newPrice_1 = 0;
            this.monthlySavings.content.payload.planPrice.forEach(function (item, index) {
                if (item.type && item.type.toUpperCase() !== 'NEW_LINE') {
                    currentPrice_1 = currentPrice_1 + item.currentPrice;
                    newPrice_1 = newPrice_1 + item.newPrice;
                }
            });
            this.totalSaving = currentPrice_1 - newPrice_1;
            if (this.monthlySavings.content.payload.existingLinePriceChanged &&
                this.isExistingPriceChanged(this.monthlySavings.content.payload.planPrice)) {
                showMonthlySavingsMessage = true;
            }
            else if (isCommonCart) {
                showMonthlySavingsMessage = true;
            }
            else {
                showMonthlySavingsMessage = false;
            }
        }
        else {
            showMonthlySavingsMessage = false;
        }
        if (showMonthlySavingsMessage) {
            return (React.createElement(React.Fragment, null,
                !showOnlyLink &&
                    React.createElement("div", { className: msstyles.msMargin },
                        React.createElement("div", { className: msstyles.msContainer },
                            React.createElement("div", { className: [styles.iconDiv, msstyles.savingicon].join(' ') },
                                React.createElement("i", { "aria-label": "Monthly Saving Message Icon", className: [icons.cccIconCart, icons.cccIconCartOffersL].join(' ') })),
                            React.createElement("div", null,
                                React.createElement("span", { className: msstyles.label24 }, this.cmsContent.hoorayLabel),
                                React.createElement("span", { className: msstyles.label16 }, this.cmsContent.savingLabel ?
                                    this.cmsContent.savingLabel.replace('{0}', Utils.amountWithDecimal(this.totalSaving, 2, '$')) : ''),
                                React.createElement("span", null,
                                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'See', 'your savings link'), "aria-label": "Cart See Your saving link", 
                                        // tslint:disable-next-line: jsx-no-lambda
                                        onClick: function () { _this.seeYourSaving(true); }, className: msstyles.mslink }, this.cmsContent.seeYourSavingLinkLabel))))),
                showOnlyLink &&
                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'See', 'See your savings'), 
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () { _this.seeYourSaving(true); }, className: msstyles.detailsLink }, this.cmsContent.seeYourSavingLinkLabel),
                this.state.showMonthlySavingsModal &&
                    React.createElement(MonthlySavingsPanel_1.default, { monthlySavings: this.monthlySavings, showModal: true, close: this.seeYourSaving, totalSavingAmt: this.totalSaving })));
        }
        else {
            return (React.createElement(React.Fragment, null, " "));
        }
    };
    MonthlySavings.prototype.isExistingPriceChanged = function (planPrice) {
        var isPriceChanged = false;
        planPrice.forEach(function (line) {
            if (line.type === 'EXISTING_LINE' && line.currentPrice > line.newPrice) {
                isPriceChanged = true;
            }
        });
        return isPriceChanged;
    };
    return MonthlySavings;
}(React.Component));
exports.default = MonthlySavings;
//# sourceMappingURL=MonthlySavings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/MonthlySavings/MonthlySavings.js
// module id = 2256
// module chunks = 8